module.exports = __webpack_public_path__ + "img/jazzhr.1d3e171e.png";